export const SAVE_ROUTES_MASTER = "SAVE_ROUTES_MASTER"
export const SAVE_ROUTES_MASTER_API_SUCCESS = "SAVE_ROUTES_MASTER_API_SUCCESS"

export const GET_ROUTES_LIST = "GET_ROUTES_LIST"
export const GET_ROUTES_LIST_SUCCESS = "GET_ROUTES_LIST_SUCCESS"

export const DELETE_ROUTES_ID = "DELETE_ROUTES_ID"
export const DELETE_ROUTES_ID_SUCCESS = "DELETE_ROUTES_ID_SUCCESS"

export const EDIT_ROUTES_ID = "EDIT_ROUTES_ID"
export const EDIT_ROUTES_ID_SUCCESS = "EDIT_ROUTES_ID_SUCCESS"

export const UPDATE_ROUTES_ID = "UPDATE_ROUTES_ID"
export const UPDATE_ROUTES_ID_SUCCESS = "UPDATE_ROUTES_ID_SUCCESS"

export const ROUTES_API_ERROR_ACTION = "ROUTES_API_ERROR_ACTION"



